export default {
  SET_SORT_BY: 'SET_SORT_BY',
  TOGGLE_GENRE: 'TOGGLE_GENRE',
  SET_RELEASE_DATE_START: 'SET_RELEASE_DATE_START',
  SET_RELEASE_DATE_END: 'SET_RELEASE_DATE_END',
};
